import { render, staticRenderFns } from "./header2022.vue?vue&type=template&id=e8562dea&scoped=true"
import script from "./header2022.vue?vue&type=script&lang=js"
export * from "./header2022.vue?vue&type=script&lang=js"
import style0 from "./header2022.vue?vue&type=style&index=0&id=e8562dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8562dea",
  null
  
)

export default component.exports